module.exports = __webpack_public_path__ + "static/img/car_7_6_cold@3x.965da82c.png";